import MenuItem from '@eversports/react-components/primitives/MenuItem'
import MonetaryValue from '@eversports/react-components/primitives/MonetaryValue'
import Select from '@eversports/react-components/primitives/Select'
import React from 'react'
import { Localized } from '../../../localization/react'

import { SelectAddOnField } from '../../../typings/AdditionalInformation'

interface Props extends SelectAddOnField {
  mandatory?: boolean
}

const SingleSelectionField: React.FC<React.PropsWithChildren<Props>> = ({ id, description, options, mandatory }) => (
  <Select name={id} label={description} required={mandatory} fullWidth>
    {mandatory && (
      <MenuItem value={''} disabled>
        <Localized id="please-choose-an-option" />
      </MenuItem>
    )}
    {options.map(({ price, ...props }) => (
      <MenuItem key={props.id} value={props.id}>
        {price ? (
          <>
            {props.description} (<MonetaryValue value={price.value} currencyCode={price.currency} />)
          </>
        ) : (
          props.description
        )}
      </MenuItem>
    ))}
  </Select>
)
SingleSelectionField.defaultProps = {
  mandatory: false,
}

export default SingleSelectionField
